import {observer} from "mobx-react";
import React from "react";

import {ConfirmDialog} from "../../molecules/confirm-dialog/confirm-dialog";
import {IListEditorItem, ListEditor} from "../../molecules/list-editor/list-editor";
import {ListEditorItemPanel} from "../../molecules/list-editor-item-panel/list-editor-item-panel";
import {AdminBreadcrumb} from "../../organisms/admin-breadcrumb/admin-breadcrumb";
import {TagAddButton} from "../../organisms/tag-add-button/tag-add-button";
import {TagItem} from "../../organisms/tag-cache/tag-cache";
import {AppLayout} from "../../templates/app-layout/app-layout";
import {TagListPageStore} from "./tag-list-page-store";

@observer
export class TagListPage extends React.Component<{pageStore: TagListPageStore}> {
    public render() {
        const items: Array<IListEditorItem<TagItem>> = this.props.pageStore.tags.map((tag) => {
            return {key: tag.slug, data: tag};
        });
        return (
            <AppLayout
                breadcrumb={<AdminBreadcrumb factory={(builder) => builder.tagList().build()} />}
                buttons={
                    <TagAddButton
                        store={this.props.pageStore.tagAddStore}
                        onCreated={this.props.pageStore.load}
                    />
                }
            >
                <ConfirmDialog
                    title="タグの削除"
                    buttonLabel="削除"
                    isOpen={this.props.pageStore.tagDeleteStore.isOpen}
                    onClose={this.props.pageStore.tagDeleteStore.close}
                    onAction={async () => {
                        await this.props.pageStore.tagDeleteStore.delete();
                        await this.props.pageStore.load();
                    }}
                >
                    {`${this.props.pageStore.tagDeleteStore.label}( ${this.props.pageStore.tagDeleteStore.slug} ) を削除します。既存の記事からも取り除かれます。`}
                </ConfirmDialog>
                <ListEditor
                    items={items}
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onChange={() => {}}
                    itemComponentFactory={(props) => (
                        <ListEditorItemPanel
                            onRemove={() => {
                                if (props.item.data?.slug) {
                                    this.props.pageStore.tagDeleteStore.open(
                                        props.item.data?.label,
                                        props.item.data?.slug,
                                    );
                                }
                            }}
                        >
                            <div style={{lineHeight: "30px"}}>
                                {props.item.data?.label} ( {props.item.data?.slug} )
                            </div>
                        </ListEditorItemPanel>
                    )}
                />
            </AppLayout>
        );
    }
}
